import {findRegionById} from '@/commons/regionFinder';
import {isInteger} from 'lodash';

export default (value: any): string => {
    if (typeof value === 'object' && value && value.region !== null) {
        return value.region;
    }

    if (isInteger(value)) {
        const vint = parseInt(value, 10);

        if (vint && vint > 0) {
            const found = findRegionById(vint);

            return found ? found.region : '';
        }
    }
    return value;
};
